import { memo } from 'preact/compat';
import type { INavbarProps } from '../types';

const tabs: { key: INavbarProps['activeTab']; label: string }[] = [
    { key: 'composition', label: 'Состав' },
    { key: 'coordinator', label: 'Обработка' },
    { key: 'selection', label: 'Отборка' },
    { key: 'protection', label: 'Информация' },
    { key: 'settings', label: 'Работа с файлом' },
];

const Navbar = memo(({ activeTab, onTabChange, isSettingsDisabled }: INavbarProps) => {
    return (
        <div className="bg-base-100 border-b border-base-300">
            <div className="flex overflow-x-auto">
                {tabs.map(({ key, label }) => (
                    <button
                        key={key}
                        className={`px-6 py-3 font-medium whitespace-nowrap flex-shrink-0 transition-colors border-b-2 ${
                            activeTab === key ? 'border-accent bg-base-200' : 'btn-ghost border-transparent'
                        } disabled:opacity-40 disabled:cursor-not-allowed`}
                        disabled={isSettingsDisabled}
                        onClick={() => onTabChange(key)}
                    >
                        {label}
                    </button>
                ))}
            </div>
        </div>
    );
});

export default Navbar;
